(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name authentication.service:AuthService
     *
     * @description
     *
     */
    angular
        .module('authentication')
        .service('AuthService', AuthService);

    function AuthService($location, $window, $interval, $state, RemoteService, EventManagerService, ApplicationService, StorageServices, PopupManager) {
        var self = this,
            isLoggedIn = false,
            timer,
            isResetPassword = false,
            bufferTimeOfTimer = 120000,
            logoutTimer; //Time in milliseconds to check before ttl expires

        self.setLogoutData = function () {
            isLoggedIn = false;
            StorageServices.set(StorageServices.KEYS.IS_LOGGED_IN, isLoggedIn);
            StorageServices.set(StorageServices.KEYS.IS_SSO_LOGGED_IN, false);
            StorageServices.clearAllTabData();
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.USER_LOGGED_OUT);
            ApplicationService.setLoginInfo(null);
            ApplicationService.closeAllOpenTabs();
            PopupManager.closeAllModals();
            destroyIdleTimer();
        };


        (function init() {
            // Skip ping/logout check during SSO callback — getSSOResult will handle login state
            if ($location.search().ref) {
                return;
            }

            isLoggedIn = !!StorageServices.get(StorageServices.KEYS.IS_LOGGED_IN);


            //If logged in Start the idle logout timer
            if (isLoggedIn && !timer) {
                var loginInfo = ApplicationService.getLoginInfo();

                //if isLoggedIn true - ping and check whether token is active
                if (!!loginInfo) {
                    RemoteService.ping(loginInfo.tokenId).then(
                        function () {
                            var ttl = loginInfo.timeToLeave,
                                now = moment(),
                                lastToken = moment(ApplicationService.getLastTokenReceivedTimestamp()),
                                timeElapsedInMinitues = moment(now).diff(lastToken, 'minutes', true);
                            if (timeElapsedInMinitues < ttl) {
                                startApplicationLogoutTimer(ttl - timeElapsedInMinitues);
                            }
                        }, function () {
                            self.setLogoutData();
                        });
                } else {
                    self.setLogoutData();
                }
            }
            //startLogoutTimer();
        })();

        var AesUtil = function (keySize, iterationCount) {
            this.keySize = keySize / 32;
            this.iterationCount = iterationCount;
        };

        AesUtil.prototype.generateKey = function (salt, passPhrase) {
            var key = CryptoJS.PBKDF2(
                passPhrase,
                CryptoJS.enc.Hex.parse(salt),
                {keySize: this.keySize, iterations: this.iterationCount});
            return key;
        };

        AesUtil.prototype.encrypt = function (salt, iv, passPhrase, plainText) {
            var key = this.generateKey(salt, passPhrase);
            var encrypted = CryptoJS.AES.encrypt(
                plainText,
                key,
                {iv: CryptoJS.enc.Hex.parse(iv)});
            return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
        };

        AesUtil.prototype.decrypt = function (salt, iv, passPhrase, cipherText) {
            var key = this.generateKey(salt, passPhrase);
            var cipherParams = CryptoJS.lib.CipherParams.create({
                ciphertext: CryptoJS.enc.Base64.parse(cipherText)
            });
            var decrypted = CryptoJS.AES.decrypt(
                cipherParams,
                key,
                {iv: CryptoJS.enc.Hex.parse(iv)});
            return decrypted.toString(CryptoJS.enc.Utf8);
        };

        function startLogoutTimer() {
            if (angular.isUndefined(logoutTimer)) {
                logoutTimer = $interval(function () {
                    if (!StorageServices.get(StorageServices.KEYS.IS_LOGGED_IN) && !isResetPassword) {
                        self.setLogoutData();
                        $location.path('/login');
                    }
                }, 1000,0,false);
            }
        }

        function enctyptMe(userName, password, newPassword) {
            var iterationCount = 3746;
            var keySize = 128;
            var plaintext = password;
            var passphrase = "aeroLineCrew" + userName + "2016";

            var ivVal = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
            var saltVal = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);

            var aesUtil = new AesUtil(keySize, iterationCount);
            var ciphertext = aesUtil.encrypt(saltVal, ivVal, passphrase, password, {padding: CryptoJS.pad.PKCS5Padding});
            var ciphertext_newPassword;
            if (!!newPassword) {
                ciphertext_newPassword = aesUtil.encrypt(saltVal, ivVal, passphrase, newPassword, {padding: CryptoJS.pad.PKCS5Padding});
            }

            return {
                ciphertext: ciphertext,
                ciphertextNewPw: ciphertext_newPassword,
                iv: ivVal,
                salt: saltVal
            }
        }

        function setLoginData(loginResponse) {
            isLoggedIn = true;
            StorageServices.set(StorageServices.KEYS.IS_LOGGED_IN, isLoggedIn);
            ApplicationService.setLoginInfo(loginResponse);
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.USER_LOGGED_IN);
            startApplicationLogoutTimer(loginResponse.timeToLeave);
            ApplicationService.setLastTokenReceivedTimestamp();
        }


      self.setSSOLoginData= function (loginResponse) {
        isLoggedIn = true;
        StorageServices.set(StorageServices.KEYS.IS_LOGGED_IN, isLoggedIn);
        ApplicationService.setLoginInfo(loginResponse);
        EventManagerService.notifyEventListeners(EventManagerService.EVENT.USER_LOGGED_IN);
        startApplicationLogoutTimer(loginResponse.timeToLeave);
        ApplicationService.setLastTokenReceivedTimestamp();
      }


     self.getCookie=function(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
      }

      self.removeCookie = function (name, path, domain) {
        var cookieString = name + '=; Max-Age=-99999999; path=' + path;
        if (domain) {
          cookieString += '; domain=' + domain;
        }
        document.cookie = cookieString;
      };

        function startApplicationLogoutTimer(timeInMinutes) {
            if (!!timeInMinutes) {
                console.log('start logout timer');
                var timeoutInMilliseconds = timeInMinutes * 60 * 1000;
                destroyIdleTimer();
                var timerDuration = timeoutInMilliseconds - bufferTimeOfTimer;
                if (timerDuration > 0) {
                    timer = $interval(onUserTokenTimerElapse, timerDuration, 0, true, timerDuration);
                }
            }
        }

        function destroyIdleTimer() {
            if (!!timer) {
                $interval.cancel(timer);
            }
        }

        function logoutUserOnTokenExpire() {
            self.doLogOut(
                function () {
                    self.setLogoutData();
                    $location.path('/login');
                    $window.location.reload();
                },
                function () {
                    console.log('logout Error');
                }
            );
        }

        function onUserTokenTimerElapse(elapsedTime) {
            console.log('User Token Timeout - Start');
            var now = moment();
            var lastToken = moment(ApplicationService.getLastTokenReceivedTimestamp());
            var lastCall = moment(ApplicationService.getLastServiceCallTime());

            if (moment(lastCall).isBetween(lastToken, now)) {
                console.log('User Token Renew Call');
                RemoteService.renewToken(ApplicationService.getTokenId()).then(
                    function (response) {
                        if (response.success) {
                            var loginInfo = ApplicationService.getLoginInfo();
                            ApplicationService.setLastTokenReceivedTimestamp();
                            startApplicationLogoutTimer(loginInfo.timeToLeave);
                        } else {
                            logoutUserOnTokenExpire();
                        }
                    },
                    function () {
                        logoutUserOnTokenExpire();
                        console.log('LOGOUT UPON USER TOKEN RENEW FAILED REQUEST FAILED');
                    }
                );
            } else {
                console.log('User Token Expires - Logout User');
                logoutUserOnTokenExpire();
            }
        }

        /**
         * Get Login Request Param
         * @PRIVATE
         * @param userNameParm
         * @param passwordParam
         * @returns {{username: *, iv: *, ciphertext, salt: *}}
         */
        function getLoginRequest(userNameParm, passwordParam) {
            var encrypted = enctyptMe(userNameParm, passwordParam),
                param = {
                    "username": userNameParm,
                    "iv": encrypted.iv,
                    "ciphertext": encrypted.ciphertext,
                    "salt": encrypted.salt
                };
            return param;
        }

        /**
         * Get Change Password Request Param
         * @PRIVATE
         * @returns {{currentPassword: string, newPassword: string, salt: string, iv: string}}
         */
        function getChangePasswordRequest(oldPassword, newPassword) {
            var userInfo = ApplicationService.getLoginInfo();
            var encrpted;
            if (!!userInfo) {
                encrpted = enctyptMe(userInfo.userName, oldPassword, newPassword);
            }

            var param = {
                currentPassword: encrpted && encrpted.ciphertext,
                newPassword: encrpted && encrpted.ciphertextNewPw,
                salt: encrpted.salt,
                iv: encrpted && encrpted.iv
            }
            return param;
        }


        /**
         * lgoin API Helper Function
         * @PUBLIC
         * @param userName
         * @param password
         * @param successFn
         * @param errorFn
         */
        self.doLogin = function (userName, password, successFn, errorFn) {

            var requestParam = getLoginRequest(userName, password);
            RemoteService.login(requestParam).then(
                function (data) {
                    if (data) {
                        data.userName = userName;
                    }
                    if (data.passwordResetReq) {
                        ApplicationService.setLoginInfo(data);
                        isResetPassword = true;
                        $state.go('reset');
                    } else {
                        setLoginData(data);
                        isResetPassword = false;
                        successFn();
                    }
                },
                function (error) {
                    self.setLogoutData();
                    errorFn(error);
                }
            );
        };

        /**
         * Logout API helper function
         * PUBLIC
         * @param successFn
         * @param errorFn
         */
        self.doLogOut = function (successFn, errorFn) {
            RemoteService.logout(ApplicationService.getTokenId()).then(
                function () {
                    self.setLogoutData();
                    successFn && successFn();
                },
                function (msg) {
                    self.setLogoutData();
                    errorFn();
                }
            );
        };

        /**
         * Change Password Helper function
         * PUBLIC
         * @param oldPassword
         * @param newPassword
         * @param successFn
         * @param errorFn
         */
        self.doChangePassword = function (oldPassword, newPassword, successFn, errorFn) {
            var requestParam = getChangePasswordRequest(oldPassword, newPassword);
            RemoteService.changePassword(requestParam).then(
                function (data) {
                    self.setLogoutData();
                    successFn(data);
                },
                function (msg) {
                    errorFn(msg);
                }
            );
        };

        /**
         * Check user logged in status
         * @returns {boolean}
         */
        self.isLoggedIn = function () {
            var local = !!StorageServices.get(StorageServices.KEYS.IS_LOGGED_IN);
            if (local !== isLoggedIn) {
                isLoggedIn = local;
                if (isLoggedIn) {
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.USER_LOGGED_IN);
                }
            }

            return isLoggedIn;
        };


        self.getCrewProfileChangePasswordRequest = function(loginID,password){
            var encrypted = enctyptMe(loginID, password),
                param = {
                    "iv": encrypted.iv,
                    "ciphertext": encrypted.ciphertext,
                    "salt": encrypted.salt
                };
            return param;
        };

      self.doAdLogin = function (successFn, errorFn) {
        RemoteService.aDLogin().then(
          function (data) {
            successFn(data)
          },
          function (error) {
            errorFn(error);
          }
        );
      };

      self.isSSOEnabled = function (successFn, errorFn) {
        RemoteService.isSSOEnabled().then(
          function (data) {
            successFn(data)
          },
          function (error) {
            errorFn(error);
          }
        );
      };



    }
}());
